import FormInputValidation from './FormInputValidation';

interface FormInputProps {
    id: string;
    type: string;
    name: string;
    label: string;
    validation: any;
    min?: number;
    max?: number;
    multiline?: boolean;
    placeholder: string;
    labelClass?: string;
    labelColor?: string;
    wrapperClass?: string;
    inputClass?: string;
    readonly?: boolean;
    rows?: number;
}

const FormInput: React.FC<FormInputProps> = ({
    id,
    name,
    type,
    label,
    validation,
    min,
    max,
    multiline,
    placeholder,
    labelClass,
    labelColor,
    wrapperClass,
    inputClass,
    readonly,
    rows,
}) => {
    return (
        <FormInputValidation
            id={id}
            name={name}
            type={type}
            label={label}
            min={min}
            max={max}
            multiline={multiline}
            validation={validation}
            placeholder={placeholder}
            labelClass={labelClass}
            labelColor={labelColor}
            wrapperClass={wrapperClass || "mb-6 space-y-1.5"}
            inputClass={inputClass || ""}
            readonly={readonly}
            rows={rows}
        />
    )
}

export default FormInput;
